import {Button, Typography} from "@mui/material"
import Grid from "@mui/material/Grid"
import {useNavigate, useParams} from "react-router-dom"

import {useAnalytics} from "@indebted/analytics"
import {Page} from "@indebted/components/Page"
import {getRegionAWSName} from "@indebted/api"

function OptOutConfirmation({I18n}) {
	const {channel} = useParams()
	const navigate = useNavigate()
	const {track} = useAnalytics()

	return (
		<Page>
			<Grid>
				<Typography align="center" variant="h6">
					{I18n.Title}
				</Typography>
			</Grid>

			<Grid>
				<Button
					fullWidth
					disableElevation
					onClick={() => {
						track("OptOutButtonClicked")
						navigate(`${channel}/confirm?region=${getRegionAWSName()}`)
					}}
				>
					{I18n.ButtonLabel}
				</Button>
			</Grid>
		</Page>
	)
}

export {OptOutConfirmation}
